import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const delpro: ImportTypeConfig = {
  dateField: {
    labelKey: 'date_milk_production',
  },
  dateFormat: true,
  importType: true,
  instructions: {
    software: 'Delpro',
    spreadsheetName: { lower: true, messageKey: 'exportable' },
  },
  type: 'delpro',
}
